export const inter = `'Inter var', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif`;
export const fontFamily = {
    default: inter,
};
export const fontSize = {
    huge: '1.25rem',
    large: '1rem',
    medium: '0.875rem',
    small: '0.75rem',
    tiny: '0.6875rem',
};
export const fontWeight = {
    regular: '400',
    medium: '500',
    semibold: '600',
    bold: '700',
    extrabold: '800',
};
export const fontStyle = {
    normal: 'normal',
    italic: 'italic',
};
export const lineHeight = {
    default: '140%',
    neutralized: '120%',
};
export const properties = {
    fontSize,
    fontWeight,
    fontStyle,
    lineHeight,
};
